import React from 'react';
import { Route, Redirect } from "react-router-dom";
import {config} from './constants/domainConfig'


const PrivateRoute = ({ component: Component, ...rest }) => {

    let isLoggedIn = false;
    let isUidExist = false;
    let isUidAuthorized = false;

    if (sessionStorage.getItem('authorized')) {
        let loginData= JSON.parse(sessionStorage.getItem('authorized'));
        if(loginData.success){
            isLoggedIn=true
        }
    }
    
    let uidData= JSON.parse(sessionStorage.getItem('uid'));
    isUidAuthorized= JSON.parse(sessionStorage.getItem('isUidAuthorized'));
    
    if(uidData != undefined && uidData.uid) {
        isUidExist=true
    }
    return (
        <Route
            {...rest}
            render={props =>
                isLoggedIn === true ? (<Component {...props} />) 
                :
                 (
                    (config.domain ==='pt' ) ?
                        <Redirect to={{ pathname: `/loginWithUsername` }} /> 
                        :
                        <Redirect to={{ pathname: '/login' }} />
                        
                )
            }
        />)
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/PrivateRoute.js